/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const GET_ORDERS_HISTORY = gql`
  query activeCustomer($options: OrderListOptions) {
    activeCustomer {
      orders(options: $options) {
        totalItems
        items {
          id
          createdAt
          updatedAt
          code
          state
          active
          currencyCode
          shipping
          shippingWithTax
          total
          totalWithTax
          subOrders {
            id
            createdAt
            updatedAt
            code
            state
            subTotal
            subTotalWithTax
            deliveryTime
            lines {
              id
              productVariant {
                id
                name
                featuredAsset {
                  source
                  preview
                }
              }
              featuredAsset {
                source
                preview
              }
              linePriceWithTax
              deliveryDate
              quantity
              cancelledQuantity
            }
          }
        }
      }
    }
  }
`;
